
import { defineComponent, PropType } from 'vue'
import { MultipleAnswerQuestion } from '@/types/Quiz'
import BlueButton from '@/components/Buttons/BlueButton.vue'
import QuestionLabel from '@/components/Labels/QuestionLabel.vue'

export default defineComponent({
  name: 'Question',
  components: { BlueButton, QuestionLabel },
  props: {
    question: {
      type: Object as PropType<MultipleAnswerQuestion>,
      required: true,
    },
    onSelect: {
      type: Function,
      required: true,
    },
    showResults: {
      type: Boolean,
    },
  },
})
